import { Lock, Megaphone, TrendingUp, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaidAds() {
  return (
    <div className="space-y-8">
      <header className="flex items-center justify-between">
        <div>
          <h1 className="font-heading text-3xl font-bold tracking-tight sm:text-4xl">Paid Ads</h1>
          <p className="mt-1 text-muted-foreground">Meta Ads, Google Ads and LinkedIn Ads — all in one place.</p>
        </div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-amber-50 px-3 py-1.5 text-xs font-semibold text-amber-700">
          <span className="h-1.5 w-1.5 rounded-full bg-amber-500" /> Paused
        </span>
      </header>

      <div className="relative overflow-hidden rounded-3xl border border-border/60 bg-card p-8 shadow-sm">
        <div className="pointer-events-none absolute inset-0 grid grid-cols-3 gap-6 p-8 opacity-[0.12] blur-[2px]" aria-hidden>
          {["Reached 63.8K", "Clicks 1.2K", "Visits 892", "Spend ₹1,070", "CTR 1.9%", "CPC ₹0.89"].map((t) => (
            <div key={t} className="rounded-2xl border border-border bg-muted/40 p-6">
              <p className="text-sm text-muted-foreground">{t.split(" ")[0]}</p>
              <p className="mt-2 font-heading text-2xl font-bold">{t.split(" ").slice(1).join(" ")}</p>
            </div>
          ))}
        </div>
        <div className="relative z-10 mx-auto max-w-lg py-10 text-center">
          <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl nuera-gradient text-white shadow-sm">
            <Megaphone className="h-7 w-7" />
          </span>
          <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight">Paid performance is coming in Phase 2</h2>
          <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">
            Nuera will bring Meta, Google and LinkedIn Ads spend, reach and conversions together — with AI insights on what to optimise. Your organic data is already flowing.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3 text-sm text-muted-foreground">
            <span className="inline-flex items-center gap-1.5"><TrendingUp className="h-4 w-4" /> Cross-channel ROAS</span>
            <span className="inline-flex items-center gap-1.5"><Sparkles className="h-4 w-4" /> AI recommendations</span>
          </div>
          <Button disabled className="mt-6 rounded-full" data-testid="paid-ads-locked">
            <Lock className="mr-1.5 h-4 w-4" /> Available in Phase 2
          </Button>
        </div>
      </div>
    </div>
  );
}
